export default __webpack_public_path__ + "static/media/content.4e23fd3b.png";